import { createBrowserHistory } from 'history';
import { matchPath } from 'react-router-dom';
import { LIST_PAGE_PATH } from './components/paths';
import { cookieToPath, documentGetCookie, pathToCookie } from './cookie';
import { changeMediaFilterAction, changeMediaFilterClientPersistent, selectShowMedia } from './ducks';

export const normalizeMediaFilterPath = (history, pathValue, match) => {
  const { mediaFilter } = match.params;
  const { location } = history;
  if (mediaFilter && pathValue) {
    history.replace(match.url.replace(mediaFilter, pathValue) + location.search, location.state);
  } else if (!mediaFilter && pathValue) {
    history.replace(`/${pathValue}${match.url === '/' ? '' : match.url}${location.search}`, location.state);
  } else if (mediaFilter && !pathValue) {
    const pathname = match.url.replace(`/${mediaFilter}`, '');
    history.replace((pathname ? pathname : '/') + location.search, location.state);
  }
};

const createCookiePathSynchronizer = ({ dispatch, getState }, history) => location => {
  const match = matchPath(location.pathname, { path: LIST_PAGE_PATH, exact: true });
  if (match) {
    const { mediaFilter } = match.params;
    const cookieMediaFilter = documentGetCookie('filterMedia');
    const cookieValue = pathToCookie(mediaFilter);
    const pathValue = cookieToPath(cookieMediaFilter);
    if (cookieMediaFilter !== cookieValue) {
      mediaFilter ?
        dispatch(changeMediaFilterClientPersistent(cookieValue)) :
        normalizeMediaFilterPath(history, pathValue, match);
    }
    if(cookieMediaFilter !== undefined && selectShowMedia(getState()) !== cookieMediaFilter) {
      mediaFilter ?
        dispatch(changeMediaFilterClientPersistent(cookieValue)) :
        dispatch(changeMediaFilterAction(cookieMediaFilter));
    }
  }
};

export const createHistory = store => {
  const history = createBrowserHistory();
  const synchronizer = createCookiePathSynchronizer(store, history);
  synchronizer(history.location);
  history.listen(synchronizer);
  return history;
};
